import type { JSX } from "react";
import { useEffect, useRef } from "react";
import { HOTSPOTS } from "@/scene/fx/hotspotRegistry";
import { runHotspotAction } from "@/lib/actions";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const InventoryPanel = ({
  open,
  onClose,
}: Props): JSX.Element | null => {
  const firstBtnRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (open) firstBtnRef.current?.focus();
  }, [open]);

  if (!open) return null;
  return (
    <aside
      role="dialog"
      aria-modal="true"
      aria-label="Inventory"
      className="absolute left-0 top-0 z-30 h-full w-[320px] border-r border-rule bg-bg1/95 p-4 backdrop-blur-md"
    >
      <header className="flex items-center justify-between border-b border-rule pb-2">
        <h2 className="font-mono text-sm uppercase tracking-wider">
          Inventory
        </h2>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close inventory"
          className="font-mono text-ink2 hover:text-phosphor"
        >
          ×
        </button>
      </header>
      <ul className="mt-3 space-y-1">
        {Object.entries(HOTSPOTS).map(([key, meta], idx) => (
          <li key={key}>
            <button
              ref={idx === 0 ? firstBtnRef : null}
              type="button"
              disabled={!meta.action}
              onClick={() => {
                if (meta.action) {
                  runHotspotAction(meta.action);
                  onClose();
                }
              }}
              className="flex w-full items-center justify-between rounded border border-rule px-3 py-2 text-left font-mono text-xs uppercase tracking-wider hover:border-phosphor disabled:opacity-50"
            >
              <span>{meta.label}</span>
              <span className="text-ink2">
                {meta.shortcut?.toUpperCase() ?? "-"}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};
